import * as React from "react";
const SvgPlayArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 11, viewBox: "0 0 9 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 10.6V0L8.36667 5.3L0 10.6Z", fill: "#333333" }));
export default SvgPlayArrow;
